export const contactusDetailConstants = {
    GET_CONTACTUS_DETAIL_REQUEST: 'GET_CONTACTUS_DETAIL_REQUEST',
    GET_CONTACTUS_DETAIL_SUCCESS: 'GET_CONTACTUS_DETAIL_SUCCESS',
    GET_CONTACTUS_DETAIL_FAILURE: 'GET_CONTACTUS_DETAIL_FAILURE',

    GET_CONTACTUS_CALL_STATUS_REQUEST: 'GET_CONTACTUS_CALL_STATUS_REQUEST',
    GET_CONTACTUS_CALL_STATUS_SUCCESS: 'GET_CONTACTUS_CALL_STATUS_SUCCESS',
    GET_CONTACTUS_CALL_STATUS_FAILURE: 'GET_CONTACTUS_CALL_STATUS_FAILURE',
}